import styled from 'styled-components';

export const QeTag = styled.div`
  border-radius: 5px;
  background-color: rgba(82, 196, 27, 0.1);
  font-size: 10px;
  font-weight: 700;
  font-style: normal;
  font-stretch: normal;
  text-transform: uppercase;
  letter-spacing: 0.71px;
  text-align: center;
  display: inline-block;
  color: #52c41b;
  padding: 5px;
  line-height: 1;

 i {
    margin-right: 5px;
  }
`;